import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: ``,
    name: 'MAINTAIN_RECORD_LIST',
    method: 'GET',
  });

  const manualRequest = function () {
    if (params) {
      let url = `/api/maintain/record`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  };

  useEffect(() => {
    manualRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [isRequestSuccessed, data || [], manualRequest];
});
